import { render, staticRenderFns } from "./FormMask.vue?vue&type=template&id=6dda0e76&"
import script from "./FormMask.vue?vue&type=script&lang=ts&"
export * from "./FormMask.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports